<template>
  <div>
    <div class="content_wrap">
      <div class="wrap">
        <div class="password_main">
          <div class="password_main_top ft24">
            <span class="second_font">修改密码</span>
          </div>
          <div class="marginTop30">
            <div class="password_item clearfix">
              <label class="password_item_l"><i>*</i>当前密码：</label>
              <div class="info_item password_item_r">
                <input
                  type="password"
                  placeholder="请输入您的初始密码"
                  v-model="initPassword"
                />
              </div>
            </div>
            <div class="password_item clearfix">
              <label class="password_item_l"><i>*</i>新密码：</label>
              <div class="info_item password_item_r">
                <input
                  type="password"
                  placeholder="请输入您的新密码"
                  v-model="newPassword"
                />
              </div>
            </div>
            <div class="password_item clearfix">
              <label class="password_item_l"><i>*</i>确认新密码：</label>
              <div class="info_item password_item_r">
                <input
                  type="password"
                  placeholder="请确认您的新密码"
                  v-model="confirmPsd"
                />
              </div>
            </div>
          </div>
          <div class="password_main_btns">
            <a href="javascript:;" class="bluebd_btn mr10" @click="cancelBtn"
              >&nbsp;取&nbsp;&nbsp;消&nbsp;</a
            >
            <a href="javascript:;" class="blue_btn ml10" @click="changePwd"
              >确认</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JSEncrypt from "../assets/js/jsencrypt";

export default {
  name: "changePassword",
  data() {
    return {
      initPassword: "",
      newPassword: "",
      confirmPsd: "",
      userNameLocal: sessionStorage.getItem("userName")
    };
  },
  methods: {
    changePwd() {
      const that = this;
      let params = {
        username: this.userNameLocal,
        password: this.initPassword, //初始密码
        newPassword: this.newPassword, //新密码
        confirmPsd: this.confirmPsd //确认密码
      };
      if (this.check.calibration(params)) {
        //cailbration 每次会校验信息是否填写，是否为空。
        if (this.newPassword == this.initPassword) {
          this.$Message.error({
            content: "修改密码不能和原密码相同！",
            duration: 2
          });
        } else if (this.confirmPsd != this.newPassword) {
          //判断新密码和确认密码是否一致。
          this.$Message.error({
            content: "两次输入的密码不一致，请重新输入！",
            duration: 2
          });
        } else {
          var encrypt = new JSEncrypt();
          encrypt.setPublicKey(
            "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAJw/nF+v0qHYsf5TxSVN97iHMydfBEsfCAVSSBSvxXtcWOOZN3fpeNoH9P5KPpxF9+BVrAynIV4dIFgRhE58aRECAwEAAQ=="
		  );
		  params.username = encrypt.encrypt(this.userNameLocal);
		  params.password = encrypt.encrypt(this.initPassword);
		  params.newPassword = encrypt.encrypt(this.newPassword);
		  params.confirmPsd = encrypt.encrypt(this.confirmPsd);
          this.http.post("/ystOpenPlatformBff/resetPwd", params, res => {
            if (res.success) {
              /*this.$Message.success('修改密码成功，请登录！');*/
              let devParams = {};
              let that = this;
              this.http.post("/ystOpenPlatformBff/financeExit", devParams, res => {
                if (res.success) {
                  that.$Message.success("修改密码成功，请重新登录！"); //修改密码成功，回到登录界面
                  sessionStorage.setItem("userName", "");
                  sessionStorage.setItem("passWord", "");
                  sessionStorage.setItem("devId", "");
                  that.$router.push("/login");
                } else {
                  that.$Message.error("网络异常，请稍后重试！");
                }
              });
            } else {
              this.$Message.error(res.message);
            }
          });
        }
      }
    },
    cancelBtn() {
      this.$router.push({ path: "developCenter/developNews" });
    }
  },
  mounted() {}
};
</script>

<style>
.content_wrap {
  padding: 30px 0;
}
</style>



// WEBPACK FOOTER //
// src/page/ChangePassword.vue